import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'


type BasketLineOption = { id: number, pdp_display_quantity: number, quantity: number }
type EndpointProductInBasket = { item_id: number, product_id: number, quantity: number, options: BasketLineOption[] }
type ProductsInBasketList = EndpointProductInBasket[]
export type ProductInBasketOption = { id: number, quantity: number }
export type ProductInBasketEntry = { itemId: number, productId: number, quantity: number, options: ProductInBasketOption[] }
export type ProductsInBasket = { [itemId: string]: ProductInBasketEntry }


const toOptions = (options: BasketLineOption[]): ProductInBasketOption[] =>
  options.map(option => ({ id: option.id, quantity: option.pdp_display_quantity }))

const productsArrayToObject = (productsInBasketList: ProductsInBasketList): ProductsInBasket => {
  return productsInBasketList.reduce<ProductsInBasket>(
    (acc, product) => {
      const entry: ProductInBasketEntry = {
        itemId: product.item_id,
        productId: product.product_id,
        quantity: product.quantity,
        options: toOptions(product.options),
      }

      return Object.assign(acc, { [product.item_id]: entry })
    }, {}
  )
}

const productsInBasketValidator = createValidate<ProductsInBasketList>()

export const parseProductsInBasket = (data: unknown): ProductsInBasket => {
  validateGuard(productsInBasketValidator, data, 'ProductsInBasket')
  return productsArrayToObject(data)
}
